import React from "react";

import { css } from "@emotion/react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { Link } from "react-router";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";
import cn from "classnames";

export const UITabs: ReactTFC<{
  elements: Array<{
    label: React.ReactNode;
    link: string;
    isActive: boolean;
    scrollToTop?: boolean;
    expectSimilarLayout?: boolean;
  }>;
}> = props => {
  return (
    <ul
      css={css`
        --m: 8px;
        ${CSS_MQ.atLeastMd} {
          --m: 12px;
        }

        grid-column-gap: var(--m);

        display: grid;
        grid-template-columns: repeat(${props.elements.length}, minmax(0, 1fr));
      `}
    >
      {props.elements.map(e => (
        <li
          key={e.link}
          className={cn(e.isActive ? "active" : undefined, "u-uppercase u-ta-center")}
          css={[
            css`
              flex-grow: 1;

              word-break: break-word;

              border-top: 2px solid currentColor;

              &.active {
                color: black;
              }

              &:hover {
                border-top: 2px solid black;
              }

              &:not(.active) {
                color: ${CSS_COLORS.Grey2};
              }
            `,
          ]}
        >
          <Link
            to={{
              pathname: e.link,
            }}
            state={{
              scrollToTop: typeof e.scrollToTop !== "undefined" ? e.scrollToTop : undefined,
              expectSimilarLayout: e.expectSimilarLayout,
            }}
            css={css`
              display: block;

              padding-top: 14px;
              ${CSS_MQ.atLeastMd} {
                padding-top: 18px;
              }

              text-decoration: none;
              color: inherit;
            `}
          >
            {e.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};
